import { onMounted, ref, computed, provide } from 'vue'
import { CDN } from '../cdn/cdn'

// Check CDN URL
const cdnUrl = CDN.getCdnUrl()
const isDEV = cdnUrl.includes('green') || cdnUrl.includes('localhost')

/** @returns {{ status: Ref<'idle' | 'loading' | 'success' | 'error' | 'data_empty'> }} */
export default function useFetch(fetchFn) {
  /** @type { Ref<'idle' | 'loading' | 'success' | 'error'> } */
  const status = ref('loading')
  const data = ref(null)

  const isSuccessfull = computed(() => status.value === 'success')

  onMounted(async () => {
    isDEV && window.SportsMode?.setWidgetLoadingState(true)

    try {
      data.value = await fetchFn()
      status.value = 'success'
    } catch (error) {
      if (error.emptyResponse) {
        status.value = 'data_empty'
      } else {
        status.value = 'error'
      }
    } finally {
      if (isDEV && window.SportsMode) {
        window.SportsMode.setWidgetLoadingState(false)
        window.SportsMode.updateApiOptions()
      }
    }
  })

  provide('status', status)

  return { status, data, isSuccessfull }
}
